<template>
  <div class="car-selected-services car-selection-overview" data-js="selected_service" v-if="selectedServices.length">
    <span class="car-subheadline">{{$t('serviceSelection.selectedService')}}</span>
    <div class="car-items">
      <div class="car-item"
           v-for="(service, index) in selectedServices"
           @click="removeService(service)"
           :key="index">
        <span class="car-text">{{service | optionTranslate}}</span>
        <span class="car-icon-remove"></span>
      </div>
    </div>
    <div class="car-error-message" v-if="requestError">{{$t('equipmentSelection.error.requestError')}}</div>
    <div class="car-error-message" v-if="emptyOffersError">{{$t('equipmentSelection.error.noOffersError')}}</div>
    <div class="car-buttons">
      <primary-btn
        @click="goNext"
        class="car-btn-primary"
        :loading="loading">
        {{$t('serviceSelection.button')}}
      </primary-btn>
    </div>
  </div>
</template>

<script>
import PrimaryBtn from '@/components/PrimaryBtn';

export default {
  name: 'SelectedServices',
  props: {
    requestError: {
      type: Boolean
    },
    emptyOffersError: {
      type: Boolean
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    selectedServices() {
      return this.$store.getters['vehicleServices/selectedServices'];
    }
  },
  methods: {
    removeService(service) {
      this.$store.dispatch('vehicleServices/removeService', service);
    },
    goNext() {
      this.$emit('goNext');
    }
  },
  components: {
    PrimaryBtn
  }
};
</script>
